import React from 'react';
import './Feature.css';


const Features = () => {
  return (
    <div className='app__features' >
      <div className="app__feature-text">
        <h1 className="app__feature-h1">Boost your links today</h1>
        <a href='#search' className='app__feature-button custom__button' >Get Started</a>
      </div>
    </div>
  )
}


export default Features;
